module.exports = __webpack_public_path__ + "img/SES_Slimliner_II_Overview.a661c1fa.jpg";